import { Mail } from "lucide-react";
import { NodeCategory, registerNode } from "../../lib/register-node";
import { EmailActionNodeEditor } from "./editor";
import { EmailActionNodePanel } from "./panel";
import { EmailActionNodeProps } from "./types";
import {
  ActionNodeDataDto,
  ActionNodeEmailConfigDto,
} from "@babackapp/private-api-client/types";

const newNodeDefaultConfig: ActionNodeEmailConfigDto = {
  templateId: null,
};
const newNodeDefaultValue: ActionNodeDataDto = {
  actionType: "send_tracking_email",
  config: newNodeDefaultConfig,
};

export default registerNode<EmailActionNodeProps["data"]>({
  type: "action:send_tracking_email",
  name: "workflowsEditor.nodes.sendEmail.title",
  description: "workflowsEditor.nodes.sendEmail.description",
  Icon: Mail,
  category: NodeCategory.ACTION,
  color: "green",
  editor: {
    component: EmailActionNodeEditor,
  },
  configPanel: {
    component: EmailActionNodePanel,
  },
  newNodeDefaultData: newNodeDefaultValue,
});

export * from "./types";
export { EmailActionNodeEditor } from "./editor";
export { EmailActionNodePanel } from "./panel";
